import { COMPLIANCE_URLS } from "../../../services/apiConfig.js";
import apiClient from "../../apiInstance.js";

export const getComplianceRules = async () => {
    try {
        const response = await apiClient.get(COMPLIANCE_URLS.GET_COMPLIANCE_RULES);
        return response.data;
    } catch (error) {
        console.error("Error fetching compliance", error);
        throw error;
    }
};

export const updateComplianceRules = async (updatedData) => {
    try {
        const response = await apiClient.post(COMPLIANCE_URLS.UPDATE_COMPLIANCE_RULES, updatedData);
        return response.data;
    } catch (error) {
        console.error("Error updating Compliance", error);
        throw error;
    }
};